// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__2mUfG","containerItemsCenter":"Skeleton_containerItemsCenter__Zt44t"};